import {
    TransactionSource,
    Transaction,
    TransactionStatus
} from "@/shared/types";
import { useCustodianSettingsStore } from "@/shared/store/custodianSettings";

export function transactionGetFormattedDisplayDescription (item: Transaction) {
    const custodianSettingStore = useCustodianSettingsStore();
    const transactionPayrollOneTimeIsAdjustment =
        custodianSettingStore.userCustodianSettings.transactionPayrollOneTimeIsAdjustment;

    switch (item.source) {
        case TransactionSource.DebitCard:
            return item.description;
        case TransactionSource.Reimbursement:
            return "Reimbursement";
        case TransactionSource.PendingActivity:
            return "Pending";
        case TransactionSource.PayrollOneTime:
            if (transactionPayrollOneTimeIsAdjustment) {
                return "Adjustment Distribution";
            }
            return "Lift Contribution";
        case TransactionSource.PayrollRecurring:
        case TransactionSource.PayrollEmployer:
        case TransactionSource.PayrollPostTax:
            return "Pay Period Contribution";
        case TransactionSource.Contribution:
            return "Contribution";
        case TransactionSource.Disbursement:
            return item.description;
        default:
            return item.description;
    }
}

export const displayStatusProcessing = "Processing";

export function transactionGetFormattedDisplayStatus (status: TransactionStatus) {
    switch (status) {
        case TransactionStatus.Processing:
            return displayStatusProcessing;
        case TransactionStatus.Contributed:
            return "Contributed";
        case TransactionStatus.Reimbursed:
            return "Reimbursed";
        case TransactionStatus.HSADebitCard:
            return "HSA debit card";
        case TransactionStatus.Transferred:
            return "Transferred";
        case TransactionStatus.Fee:
            return "Fee";
        case TransactionStatus.Complete:
            return "Complete";
        case TransactionStatus.Rejected:
            return "Rejected";
        case TransactionStatus.Disbursed:
            return "Disbursed";
        case TransactionStatus.Adjustment:
            return "Adjustment";
        case TransactionStatus.UnKnown:
            return "";
        default:
            return "Unknown";
    }
}